import React from 'react';
import { Trans } from 'react-i18next';

import { Modal } from '@/components';
import { addEmailLogin, removeEmailLogin } from '@/components/RabbykitProvider';
import { history } from '@/utils';

import {
  getCurrentAddress,
  getConnectAddress,
  getconnectedDict,
  setCurrentAddress,
} from '../address';
import { signLogin } from './SignLoginModal';
import { pcConnect } from '../web3';
// import { getAccount } from '@wagmi/core';
import { selectLoginMehod } from './LoginMethodModal';

// 只要 connect 钱包的
export const onlyConnectWalletModal = async () => {
  // if (getAccount().isConnected) {
  //   return getAccount().address;
  // }
  removeEmailLogin();
  return pcConnect();
};

// 不需要钱包的，大部分是这种登陆
// 只要一个 session_id 就满足需求的情况
export const login = async (forceLogin?: boolean) => {
  if (!forceLogin && history.location.pathname && history.location.pathname !== '/') {
    history.push({
      pathname: '/',
      state: {
        // see NeedLogin.tsx / Welcome/DesktopContainer
        wantedLocation: window.location.href.slice(window.location.origin.length),
      },
    });

    return;
  }
  const connectedAddress = getConnectAddress();

  try {
    // 第一次登陆后，尝试获取 connect 地址
    addEmailLogin();
    if (connectedAddress) {
      await pcConnect({ onlyReconnect: true, isLogin: true });
    } else {
      await pcConnect({ isLogin: true });
    }

    const loggedAddr = await selectLoginMehod({ hasConnected: !!connectedAddress });

    return loggedAddr;
  } catch (error) {}
};

// 必须有个已连接的钱包
// 保证当前登陆账号与钱包内（Rabby）当前账号相同
export const loginWallet = async () => {
  let connectAddress = getConnectAddress();

  if (!connectAddress) {
    await Modal.info({
      title: <Trans i18nKey="Wallet_UserLogin.bwy43e"></Trans>,
      content: <Trans i18nKey="Wallet_UserLogin.loginDesc"></Trans>,
      confirmBtnText: <Trans i18nKey="Wallet_UserLogin.1lwpsfj"></Trans>,
    });

    connectAddress = (await onlyConnectWalletModal())?.toLowerCase();

    if (!connectAddress) {
      return Promise.reject('noConnected');
    }
  }

  const currentAddress = getCurrentAddress();
  const connectDict = getconnectedDict();

  if (connectAddress !== currentAddress) {
    Modal.info({
      title: <Trans i18nKey="Wallet_UserLogin.switchTip"></Trans>,
      content: (
        <Trans
          i18nKey="Wallet_UserLogin.switchTipDesc"
          values={{ address: currentAddress }}></Trans>
      ),
    });

    return Promise.reject('diffAddress');
  }

  if (connectDict[connectAddress!]?.sessionId) {
    setCurrentAddress(connectAddress!);

    return;
  }

  return signLogin({});
};
